// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1RY8O","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__24VLg"};